export default {
    schoolId: 1166,
    abbr: 'snut'
}